import { isNegativeNumber } from './is-negative-number.util'

export const formatPrice = (price, { showPositiveSign, currencySign }) => {
  const priceSign = showPositiveSign ? isNegativeNumber(price) ? '-' : '+' : ''

  return `${priceSign}${currencySign || ''}${Math.abs(price).toLocaleString("en-US")}`
}